import { IApplicationState } from '../../types/redux';

export const selectPriceFilters = (state: IApplicationState) => {
  const { savedFilters } = state.filters;

  return {
    priceFrom: savedFilters.priceFrom,
    priceTo: savedFilters.priceTo,
  };
};
